import { render } from "./perfiles.vue?vue&type=template&id=d0bf83ce"
import script from "./perfiles.vue?vue&type=script&lang=js"
export * from "./perfiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__